module.exports = __webpack_public_path__ + "img/pop_xinyinghu03@2x.6247d0d4.png";